import {ApiClient} from '@hconnect/apiclient'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'

type Variables = {plantCode: string; materialId: number; date: string; level: number}

export const useCreateStockLevelOverwrite = ({
  onError,
  onSuccess
}: {
  onError?: (error: AxiosError, variables: Variables) => void
  onSuccess?: (data: void, variables: Variables) => void
} = {}) =>
  useMutation<void, AxiosError, Variables>({
    mutationFn: async ({plantCode, materialId, date, level}) => {
      await ApiClient.axiosInstance.post<void>(
        `/plants/${plantCode}/material-storage/stock-level/material/${materialId}`,
        {date, level}
      )
    },
    onError,
    onSuccess
  })
